import React, { useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import "../../template/header/header.scss";

const Header = () => {
  const companyName = window.localStorage.getItem("companyName");
  const companyLogo = window.localStorage.getItem("companyLogo");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.search) {
      const queryVar = new URLSearchParams(location.search);
      const companyName = queryVar.get("companyName");
      const companyLogo = queryVar.get("companyLogo");
      const companyBanner = queryVar.get("companyBanner");
      const source = queryVar.get("source");
      const utmSource = queryVar.get("utm_source");
      const utmCampaign = queryVar.get("utm_campaign");
      const utmMedium = queryVar.get("utm_medium");
      const utmTerm = queryVar.get("utm_term");
      const utmContent = queryVar.get("utm_content");

      if (companyName) window.localStorage.setItem("companyName", companyName);
      if (companyLogo) window.localStorage.setItem("companyLogo", companyLogo);
      if (companyBanner)
        window.localStorage.setItem("companyBanner", companyBanner);
      if (source) window.localStorage.setItem("source", source);
      if (utmSource) window.localStorage.setItem("utm_source", utmSource);
      if (utmCampaign) window.localStorage.setItem("utm_campaign", utmCampaign);
      if (utmMedium) window.localStorage.setItem("utm_medium", utmMedium);
      if (utmTerm) window.localStorage.setItem("utm_term", utmTerm);
      if (utmContent) window.localStorage.setItem("utm_content", utmContent);

      queryVar.delete("companyName");
      queryVar.delete("companyLogo");
      queryVar.delete("companyBanner");
      queryVar.delete("source");
      queryVar.delete("utm_source");
      queryVar.delete("utm_campaign");
      queryVar.delete("utm_medium");
      queryVar.delete("utm_term");
      queryVar.delete("utm_content");

      const newParam = queryVar.toString();
      navigate(`/roi-calculator?${newParam}`);
    }
  }, [navigate, location.search]);

  return (
    Boolean(companyName || companyLogo) && (
      <div className="template-header" data-testid="template-header">
        <div className="inner">
          {!!companyName && (
            <div className="company" data-testid="company-name">
              {companyName}
            </div>
          )}
          {!!companyLogo && (
            <img
              src={companyLogo}
              alt={companyName}
              className="logo"
              data-testid="company-logo"
            />
          )}
        </div>
      </div>
    )
  );
};

export default Header;
